import React from "react";
import {
  Row,
  Col,
  Typography,
  Tooltip,
  Input,
  Button,
  Empty,
  Select,
  Space,
} from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import LoadingInline from "../Popup/loading-inline";
import { createTempChecklist } from "@src/redux/checkList";
import format from "@src/utils/format";
import InfiniteScroll from "react-infinite-scroller";
import { useSelector } from "react-redux";
import {
  getChecklistsFiltered,
  getGroups,
  updateOffsetFilterChecklist,
} from "@src/redux/checkList";
import { fromUnixTime } from "date-fns/esm";
import { lang, KEY, COMMON_CONSTANT } from "@src/constants/common.const";
import StatusConst from "../../constants/status.const";
import classDdl from "../../models/control/dropdownlist";
import { renderOption } from "../../constants/utils";
import { useMediaQuery } from "react-responsive";
const { Paragraph } = Typography;
function ListCheckList({ dataList, isLoadingMore, type, groupId, hasMore }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [dataSearch, updateDataSearch] = React.useState(null);
  const goToDetail = (obj) => {
    dispatch(createTempChecklist(obj, history));
  };
  const inputSearch = React.useRef(null);
  const { isLoadMoreFiltered, offsetFilteredChecklist, offsetGroupChecklist } =
    useSelector((state) => state.checklist);
  const { selectedFactory } = useSelector((state) => state.auth);
  const [ddlStatusMachine, setDdlStatusMachine] = React.useState(
    new classDdl(null, lang.MACHINE_STATUS_VALUE)
  );
  const ddlStatusMachineRef = React.useRef(
    new classDdl(null, lang.MACHINE_STATUS_VALUE)
  );

  const handleChange = (v) => {
    ddlStatusMachineRef.current.value = v;
    forceUpdate();
  };
  const [, forceUpdate] = React.useReducer((x) => x + 1, 0);

  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });

  // React.useEffect(() => {
  //   // if (dataSearch && type === "checklistFilter") {
  //   //   dispatch(updateOffsetFilterChecklist(0));
  //   // }
  // }, [dataSearch, dispatch, type]);
  const updateLoadingData = () => {
    if (type === "checklistFilter") {
      dispatch(
        getChecklistsFiltered(
          { type: "update" },
          selectedFactory,
          offsetFilteredChecklist,
          ddlStatusMachineRef.current.value
        )
      );
    } else if (type === "group") {
      dispatch(
        getGroups({ offset: offsetGroupChecklist[groupId], groupId: groupId })
      );
    } else {
      dispatch(
        getGroups({
          offset: offsetGroupChecklist[groupId],
          groupId: groupId,
          type: Number(type),
        })
      );
    }
  };
  const updateDataFilter = () => {
    if (type === "checklistFilter") {
      dispatch(
        getChecklistsFiltered(
          {
            type: "search",
            name: dataSearch.trim(),
          },
          selectedFactory,
          offsetFilteredChecklist,
          ddlStatusMachineRef.current.value
        )
      );
    }
  };
  // clear
  const clearInputSearch = () => {
    if (
      (inputSearch && inputSearch.current) ||
      ddlStatusMachineRef.current.value
    ) {
      inputSearch.current.state.value = "";
      ddlStatusMachineRef.current.value = null;
      // setDdlStatusMachine(new classDdl(null, lang.MACHINE_STATUS_VALUE));
      searchChecklist("", null);
    }
  };
  const searchChecklist = (value, valueStatus) => {
    updateDataSearch(value);
    if (type === "checklistFilter") {
      const paramsFilter = {
        type: "search",
        name: value ? value.trim() : value,
      };
      if (groupId === "isNotPreUseChecklist") {
        paramsFilter.isPreUseChecklist = 0;
      } else if (groupId === "isPreUseChecklist") {
        paramsFilter.isPreUseChecklist = 1;
      }
      dispatch(
        getChecklistsFiltered(
          paramsFilter,
          selectedFactory,
          0,
          ddlStatusMachineRef.current.value
        )
      );
      sessionStorage.setItem("searchKey", value);
      sessionStorage.setItem("searchKeyStatus", valueStatus);
    }
  };
  // const getAllChecklist = (value) => {
  //   // if (value === "" && dataSearch) {
  //   //   dispatch(getChecklistsFiltered({ type: "first" }, selectedFactory));
  //   // }
  // };
  function renderListData(dataList) {
    return (
      <>
        <Row gutter={[20, 20]}>
          {dataList.map((item, index) => (
            <Col id="animation" key={index} xs={24} md={12} lg={6}>
              <div
                className="itemList itemList-row"
                onClick={() => goToDetail(item)}
              >
                <div className="id">
                  <Row>
                    <Col flex="auto">
                      {lang.ID}: {item.id}
                    </Col>
                    <Col flex="none">
                      <div
                        style={{
                          color:
                            StatusConst.TYPE_CHECKLIST_COLOR[
                              item.isPreUseChecklist
                                ? item.isPreUseChecklist
                                : KEY.TYPE_DEFAULT_CHECKLIST
                            ],
                        }}
                      >
                        {
                          StatusConst.TYPE_CHECKLIST_STATUS[
                            item.isPreUseChecklist
                              ? item.isPreUseChecklist
                              : KEY.TYPE_DEFAULT_CHECKLIST
                          ]
                        }
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="title">
                  <Paragraph ellipsis={{ rows: 2 }} className="text-weight-600">
                    <Tooltip title={item.checklistName}>
                      {item.checklistName}
                    </Tooltip>
                  </Paragraph>
                </div>
                <div>
                  <Row justify="space-between">
                    <Col>{item.createName}</Col>
                    <Col className="created">
                      {format(
                        fromUnixTime(Number(item.createDatetime)),
                        KEY.DATE_WITH_HOUR
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        <Row className="rowNotMargin" align="middle" justify="center">
          <Col>
            <LoadingInline isLoadingInline={isLoadingMore} />
          </Col>
        </Row>
      </>
    );
  }

  React.useEffect(() => {
    const keepValueSearch = sessionStorage.getItem("searchKey");
    const keepValueSearchStatus = sessionStorage.getItem("searchKeyStatus");

    if (inputSearch && inputSearch.current) {
      inputSearch.current.state.value = keepValueSearch || "";
    }
    if(ddlStatusMachineRef){
      ddlStatusMachineRef.current.value = Number(keepValueSearchStatus) || null
    }
    searchChecklist(keepValueSearch || "", keepValueSearchStatus || null);
  }, []);
  return (
    <Row className="rowNotMargin">
      {type === "checklistFilter" && (
        <Col span={24} style={{ paddingBottom: "20px" }}>
          <Row className="rowNotMargin " gutter={[8, 8]}>
            <Col lg={7} xs={24} style={{ marginRight: "8px" }}>
              <Input
                maxLength="255"
                placeholder={lang.CHECKLIST_NAME}
                allowClear
                // onChange={(e) => getAllChecklist(e.target.value)}
                onPressEnter={(e) =>
                  searchChecklist(
                    e.target.value,
                    ddlStatusMachineRef.current.value
                  )
                }
                ref={inputSearch}
              />
            </Col>
            <Col lg={4} xs={24} style={{ marginRight: "8px" }}>
              {/* <Select
                value={ddlStatusMachine.value}
                placeholder={lang.STATUS_MACHINE}
                className="w100"
                onChange={(v) => {
                  setDdlStatusMachine({
                    ...ddlStatusMachine,
                    value: v,
                  });
                }}
              >
                {renderOption(ddlStatusMachine.options)}
              </Select> */}
              <Select
                value={ddlStatusMachineRef.current.value}
                placeholder={lang.STATUS_MACHINE}
                className="w100"
                onChange={handleChange}
              >
                {renderOption(ddlStatusMachineRef.current.options)}
              </Select>
            </Col>
            <Col lg={4} xs={24}>
              <Space>
                <Button
                  onClick={() =>
                    searchChecklist(
                      inputSearch.current.state.value,
                      ddlStatusMachineRef.current.value
                    )
                  }
                  className="buttonPC button--info"
                  icon={<SearchOutlined />}
                >
                  {lang.SEARCH}
                </Button>
                <Button
                  className="buttonPC button--outline --todo-- wAuto "
                  onClick={() => clearInputSearch()}
                >
                  <ClearOutlined />
                  {lang.CLEAR}
                </Button>
              </Space>
            </Col>
          </Row>
        </Col>
      )}
      {dataList && dataList.length ? (
        <Col span={24}>
          <Row style={{ paddingBottom: "20px" }} gutter={[16, 16]}>
            <Col span={24}>
              {dataSearch || ddlStatusMachineRef.current.value ? (
                dataSearch.length || ddlStatusMachineRef.current.value ? (
                  <InfiniteScroll
                    initialLoad={false}
                    pageStart={0}
                    hasMore={!isLoadingMore && isLoadMoreFiltered}
                    loadMore={() => updateDataFilter()}
                    useWindow={true}
                  >
                    {renderListData(dataList)}
                  </InfiniteScroll>
                ) : (
                  <Row
                    className="rowNotMargin"
                    align="middle"
                    justify="center"
                    style={{ paddingTop: "8px" }}
                  >
                    {COMMON_CONSTANT.EMPTY_DATA}
                  </Row>
                )
              ) : (
                <InfiniteScroll
                  initialLoad={false}
                  pageStart={0}
                  hasMore={
                    type === "checklistFilter"
                      ? !isLoadingMore && isLoadMoreFiltered
                      : !isLoadingMore && hasMore
                  }
                  loadMore={() => updateLoadingData()}
                  useWindow={true}
                >
                  {renderListData(dataList)}
                </InfiniteScroll>
              )}
            </Col>
          </Row>
        </Col>
      ) : isLoadingMore ? (
        <LoadingInline />
      ) : (
        <Col span={24}>
          <div className="center mt20">
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        </Col>
      )}
    </Row>
  );
}
export default ListCheckList;
